import { useEffect, useState } from "react";
import { NewsCategoryResponse, NewsResponse } from "./interface";
import AdminAPI from "../../api/admin";
import { useSetRecoilState } from "recoil";
import { loadingState } from "../../recoil/loading.atom";
import { FormProps } from "../../components/form/interface/formInterface";
import DivStyle from "../../components/style/div.component";
import Table from "../../components/table/Table";
import Page from "../../components/table/paging";
import SmallForm from "../../components/form/small_form";
import SearchRunnerCompetition from "./component/SearchRunnerCompetition";

const News = () => {
  const [dataList, setDataList] = useState<NewsResponse[]>([]);
  const [searchDataList, setSearchDataList] = useState<NewsResponse[]>([]);
  const [categoryList, setCategoryList] = useState<NewsCategoryResponse[]>([]);
  const [mode, setMode] = useState("I");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const setIsLoading = useSetRecoilState(loadingState);
  const [id, setId] = useState(0);
  const [title, setTitle] = useState("");
  const [contentHtml, setContentHtml] = useState("");
  const [mainImageKey, setMainImageKey] = useState("");
  const [category, setCateGory] = useState<NewsCategoryResponse | null>(null);
  const [runnerCompetitionIds, setRunnerCompetitionIds] = useState<number[]>(
    []
  );
  const [authorName, setAuthorName] = useState("");
  const [isCompetition, setIsCompetition] = useState(false);
  const [published, setPublished] = useState(false);
  const [main, setMain] = useState(false);
  const [today, setToday] = useState(false);
  const [link, setLink] = useState("");
  const [year, setYear] = useState(0);
  const [month, setMonth] = useState(0);
  const [mainTitle, setMainTitle] = useState("");
  const [mainCoverImageUrl, setMainCoverImageUrl] = useState("");
  const [selectedCoverFile, setSelectedCoverFile] = useState(null);

  // Create form fields conditionally based on category
  const getFormFields = () => {
    const baseFields = [
      {
        value: title,
        setValue: setTitle,
        label: "제목",
        width: "100%",
        type: "input",
      },
      {
        value: published,
        setValue: setPublished,
        label: "게시",
        width: "100%",
        type: "check",
      },
      {
        value: main,
        setValue: setMain,
        label: "메인",
        width: "100%",
        type: "check",
      },
      {
        value: today,
        setValue: setToday,
        label: "오늘의 뉴스",
        width: "100%",
        type: "check",
      },
      {
        value: link,
        setValue: setLink,
        label: "출처 링크",
        width: "100%",
        type: "input",
      },
      {
        value: category,
        setValue: setCateGory,
        options: categoryList,
        label: "카테고리",
        width: "100%",
        type: "category",
      },
      {
        value: runnerCompetitionIds,
        setValue: setRunnerCompetitionIds,
        label: "연관 본사 대회 id",
        width: "100%",
        isOpen: isCompetition,
        setIsOpen: setIsCompetition,
        type: "search-group",
      },
      {
        value: authorName,
        setValue: setAuthorName,
        label: "작성자",
        width: "100%",
        type: "input",
      },
      {
        value: contentHtml,
        setValue: setContentHtml,
        label: "내용",
        width: "100%",
        type: "editor",
      },
      {
        value: selectedFile,
        setValue: setSelectedFile,
        label: "사진",
        width: "100%",
        type: "file",
      },
      {
        value: mainImageKey,
        setValue: setMainImageKey,
        label: "사진",
        width: "25%",
        type: "image",
      },
    ];

    // Add interview-specific fields if category is INTERVIEW
    if (category && category.name === "INTERVIEW") {
      return [
        ...baseFields,
        {
          value: year,
          setValue: setYear,
          label: "연도",
          width: "100%",
          type: "input",
        },
        {
          value: month,
          setValue: setMonth,
          label: "월",
          width: "100%",
          type: "input",
        },
        {
          value: mainTitle,
          setValue: setMainTitle,
          label: "썸네일 제목",
          width: "100%",
          type: "input",
        },
        {
          value: selectedCoverFile,
          setValue: setSelectedCoverFile,
          label: "메인 커버 이미지",
          width: "100%",
          type: "file",
        },
        {
          value: mainCoverImageUrl,
          setValue: setMainCoverImageUrl,
          label: "메인 커버 이미지 URL",
          width: "25%",
          type: "image",
        },
      ];
    }

    return baseFields;
  };

  const formData: FormProps = {
    title: "상세정보",
    form: getFormFields(),
  };

  const headers = [
    {
      text: "ID",
      align: "center",
      sortable: false,
      value: "id",
    },
    {
      text: "제목",
      align: "center",
      sortable: false,
      value: "title",
    },
    {
      text: "작성자",
      align: "center",
      sortable: false,
      value: "authorName",
    },
    {
      text: "생성일자",
      align: "center",
      sortable: false,
      value: "createdAt",
    },
    {
      text: "게시",
      align: "center",
      sortable: false,
      value: "isPublished",
    },
  ];

  const addForm = async () => {
    setId(0);
    setMode("I");
    setTitle("");
    setContentHtml("");
    setAuthorName("");
    setCateGory(null);
    setMainImageKey("");
    setSelectedFile(null);
    setPublished(false);
    setMain(false);
    setToday(false);
    setLink("");
    // Reset interview-specific fields
    setYear(0);
    setMonth(0);
    setMainTitle("");
    setMainCoverImageUrl("");
    setSelectedCoverFile(null);
  };

  const save = async () => {
    if (!id) {
      return;
    }
    if (window.confirm("수정 하시겠습니까?")) {
      setIsLoading(true);
      const body = {
        id,
        title,
        contentHtml,
        category,
        authorName,
        isPublished: published,
        isMain: main,
        isToday: today,
        link,
        runnerCompetitionIds,
      };

      // Add interview-specific fields if category is INTERVIEW
      if (category && category.name === "INTERVIEW") {
        Object.assign(body, {
          year,
          month,
          mainTitle,
        });
      }

      console.log(body);
      const formData = new FormData();
      formData.append("news", JSON.stringify(body));
      if (selectedFile) {
        formData.append("image", selectedFile);
      }
      // Add cover image if category is INTERVIEW and cover file is selected
      if (category && category.name === "INTERVIEW" && selectedCoverFile) {
        formData.append("cover_image", selectedCoverFile);
      }

      const result = await AdminAPI.updateNews(formData, id);
      if (result) {
        alert("수정되었습니다.");
        addForm();
        getNews();
      }
      setIsLoading(false);
    }
  };

  const add = async () => {
    if (window.confirm("신규 등록 하시겠습니까?")) {
      setIsLoading(true);
      const body = {
        title,
        contentHtml,
        category,
        authorName,
        isPublished: published,
        isMain: main,
        isToday: today,
        link,
        runnerCompetitionIds,
      };

      // Add interview-specific fields if category is INTERVIEW
      if (category && category.name === "INTERVIEW") {
        Object.assign(body, {
          year,
          month,
          mainTitle,
        });
      }

      if (!selectedFile) {
        alert("썸네일 이미지를 선택해주세요.");
        return;
      }
      const formData = new FormData();
      formData.append("news", JSON.stringify(body));
      formData.append("image", selectedFile);

      // Add cover image if category is INTERVIEW and cover file is selected
      if (category && category.name === "INTERVIEW" && selectedCoverFile) {
        formData.append("cover_image", selectedCoverFile);
      }

      const res = await AdminAPI.registerNews(formData);
      if (res) {
        alert("등록되었습니다.");
        addForm();
        getNews();
      }
      setIsLoading(false);
    }
  };

  const remove = async () => {
    if (window.confirm("삭제 하시겠습니까?")) {
      if (id) {
        setIsLoading(true);
        const res = await AdminAPI.deleteNews(id);
        if (res) {
          alert("삭제되었습니다.");
          getNews();
          addForm();
        }
        setIsLoading(false);
      }
    }
  };

  const setDetail = (item: NewsResponse) => {
    setId(item.id);
    setMode("U");
    setTitle(item.title);
    setContentHtml(item.contentHtml);
    setAuthorName(item.authorName);
    setCateGory(item.category);
    setRunnerCompetitionIds(item.runnerCompetitionIds);
    setMainImageKey(item.mainImageKey);
    setSelectedFile(null);
    setPublished(item.isPublished);
    setMain(item.isMain);
    setToday(item.isToday);
    setLink(item.link);
    // Set interview-specific fields if present
    setYear(item.year || 0);
    setMonth(item.month || 0);
    setMainTitle(item.mainTitle || "");
    setMainCoverImageUrl(item.mainCoverImageUrl || "");
    setSelectedCoverFile(null);
  };

  function formatDate(dateString: string) {
    if (!dateString) {
      return "Invalid Date";
    }

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 월은 0부터 시작하므로 1을 더합니다.
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const getNews = async () => {
    console.log("getNews");
    const news = await AdminAPI.getNews();
    const newsCategory_res = await AdminAPI.getNewsCategory();
    if (!newsCategory_res) {
      return;
    }
    setCategoryList(newsCategory_res);
    if (!news) {
      return;
    }
    const updatedData = news.map((item: NewsResponse) => ({
      ...item,
      createdAt: formatDate(item.createdAt),
    }));
    const totalPages = Math.ceil(updatedData.length / 10);
    console.log(updatedData);
    setTotalPages(totalPages);
    setDataList(updatedData);
    setSearchDataList(updatedData);
  };

  useEffect(() => {
    getNews();
  }, []);

  return (
    <DivStyle
      style={{ overflow: "auto" }}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="column"
      marginTop="65px"
      setMobile={true}
    >
      <DivStyle
        width="100%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileTable={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
          홀덤 뉴스
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="20px"
        >
          <DivStyle
            width="100%"
            display="flex"
            flex_direction="row"
            justify_content="space-between"
            align_items="center"
          >
            <DivStyle
              width="100%"
              display="flex"
              flex_direction="row"
              justify_content="end"
              align_items="center"
            ></DivStyle>
          </DivStyle>

          <Table
            addForm={addForm}
            headers={headers}
            currentPage={currentPage}
            dataList={dataList}
            setDetail={setDetail}
          />
          <Page
            currentPage={currentPage}
            totalPages={totalPages}
            dataList={dataList}
            setCurrentPage={setCurrentPage}
          />
        </DivStyle>
      </DivStyle>
      <DivStyle
        width="100%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>폼</h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm
            form={formData.form}
            title={formData.title}
            save={save}
            add={add}
            mode={mode}
            remove={remove}
          />
        </DivStyle>
      </DivStyle>
      {isCompetition && (
        <SearchRunnerCompetition
          setRunnerCompetitionIds={setRunnerCompetitionIds}
          setIsOpen={setIsCompetition}
        />
      )}
    </DivStyle>
  );
};

export default News;
